import * as React from 'react';
import { Location } from 'history';
import LoggedInHomepage from './homepage/logged_in';
import LoggedOutHomepage from './homepage/logged_out';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { MParticlePageName, trackPageView } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/dist/elog/mparticle';
import { canViewFinancingOptions, canViewRuleOfOneHundredDiscountDisplay } from '@reverbdotcom/commons/dist/user_context_helpers';
import { experiments } from '../shared/constants';

interface IProps extends IUserContext {
  location?: Location;
}

export class Reverb extends React.Component<IProps, any> {
  componentDidMount() {
    this.logView();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.location && this.props.location) {
      this.logView();
    }
  }

  affirmHomepageExperimentKey() {
    if (!canViewFinancingOptions(this.props.user)) { return []; }
    return [experiments.AFFIRM_HOMEPAGE_CALLOUTS];
  }

  ruleOfOneHundredExperimentKey() {
    if (!canViewRuleOfOneHundredDiscountDisplay(this.props.user)) { return []; }

    return [experiments.RULE_OF_100_PRICE_DISPLAY];
  }

  logView() {
    trackPageView({
      pageName: MParticlePageName.Homepage,
      experiments: formatExperimentsForEventAttributes(this.props.user, [
        experiments.DUMMY,
        experiments.MV_DUMMY,
        ...this.affirmHomepageExperimentKey(),
        ...this.ruleOfOneHundredExperimentKey(),
      ]),
    });
  }

  render() {
    if (this.props.user.loggedOut) {
      return <LoggedOutHomepage />;
    }

    return <LoggedInHomepage />;
  }
}

export default withUserContext(Reverb);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage.tsx